export const groupType = {
  DP: {
    title: 'Dinner Parties',
    enum: 1,
  },
  TABLE: {
    title: 'Tables',
    enum: 4,
  },
  TEAM: {
    title: 'Teams',
    enum: 2,
  },
  CUSTOM: {
    title: 'Custom Group',
    enum: 3,
  },
  ALL: {
    title: 'All',
    enum: 0,
  },
};
